import * as React from "react";
import { SVGProps } from "react";
const SvgMyProduct = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 1a2 2 0 0 1 2 2v25a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h20Zm0 2H6v25h20V3Zm-4 11.5v2H10v-2h12Zm0-6v2H10v-2h12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMyProduct;
